import { Mtds } from 'prove-common'

type DateInputWidgetProps = {
  className?: string
  disabled?: boolean
  id: string
  onChange: (value: string) => void
  placeholder?: string
  readonly?: boolean
  required?: boolean
  formatMinimum?: string
  formatMaximum?: string
  value?: string
}

export const DateInputWidget = ({
  className,
  disabled,
  id,
  onChange,
  placeholder,
  readonly,
  required,
  formatMinimum,
  formatMaximum,
  value = ''
}: DateInputWidgetProps) => {
  return (
    <Mtds.Input
      type='date'
      id={id}
      lang='nb-NO'
      value={value}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      readOnly={readonly}
      onChange={({ target }) => onChange(target.value)}
      min={formatMinimum}
      max={formatMaximum}
      className={className}
    />
  )
}
